export const CLAIM_STATUS = {
	active: "ACTIVE",
	expired: "EXPIRED"
};
